<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">
      <v-container-fluid>

        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              Ingresaron tus Datos!
            </v-card-title>
            <v-card-text>Estas participando con éxito para el sorteo</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <header id="main-cabecera"   style="height: 60px; width: 100%; left:0; top:0; position: fixed">
          <v-row align="center" v-bind:style="styleCabecera" class="text-center">
            <v-col cols="6" sm="6" md="6" lg="6" style="text-align: right;">
              <h1 v-if="logoexist" class="display-1 font-weight-bold">
                <v-img style="height: 50px;" contain :src="logoimg" />
              </h1>
              <h1 v-else>{{titulonegocio}}</h1>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6">
              <v-img style="height: 50px;" contain src="@/assets/logo_perumin.png" />

            </v-col>
          </v-row>
        </header>
        <section id="main-cuerpo" v-bind:style="stylePagina" >
          <v-row justify="center" ref="cuerpo"  v-bind:style="styleMain">
            <v-col  cols="10" sm="10" md="10" lg="10">
              <v-img contain src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/imagencabecera.png"></v-img>
              <center><v-btn style="display: none;" fab small color="#ED9B33" @click="scrollToCuerpo"><v-icon color="white">fas fa-chevron-down</v-icon></v-btn></center>
            </v-col>
          </v-row>
          <v-row  justify="center" ref="cuerpo2" style="background-color: #ED9B33; ">
            <v-col cols="12" sm="12" md="12" lg="12"></v-col>
          </v-row>
          <v-row justify="center"   v-bind:style="styleMain" align="center"><v-col cols="9"  style="text-align: justify; color:#858389 !important; text-align: center; word-break: normal ;font-size: 20pt; font-weight: bolder; padding-top:50px;" > <v-btn style="display: none;" fab small color="#ED9B33" @click="scrollToCabecera" ><v-icon color="white">fas fa-chevron-up</v-icon></v-btn><p> Participa del sorteo llenando el formulario </p><p>Fecha del Sorteo: Jueves 28/09</p>
          </v-col></v-row>
          <v-row  justify="center" v-bind:style="styleMain" align="center">

            <v-col  cols="10" sm="10" md="8" lg="8" style="padding-top: 0px !important;">

              <v-card class="ma-6" v-bind:style="styleForm" elevation="10">


                <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col  cols="12" sm="6" md="6">
                    <v-autocomplete v-bind:style="styleComponent"  v-model="editedItem.tipoDocumento" :items="tiposdoc"  item-text="tipoDocumento"  persistent-hint
                                     return-object
                                     single-line :label="labelTipoDocumento"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.dni" :label="labelDNI" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.email" :label="labelEmail" :rules="emailRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.nombre" :label="$t('formularios.nombres')"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.apellidoPaterno" :label="$t('formularios.ApPaterno')"></v-text-field>
                  </v-col>
                  <v-col v-if="campoapmaterno" cols="6" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.apellidoMaterno" :label="$t('formularios.ApMaterno')"></v-text-field>
                  </v-col>
                  <v-col v-if="campotelefono" cols="12" sm="6" md="6">
                    <v-text-field type="number" v-model="editedItem.telefono" :label="$t('formularios.Telefono')"></v-text-field>
                  </v-col>
                  <v-col v-if="campodireccion" cols="12" sm="6" md="6">
                    <v-text-field  v-model="editedItem.direccion" :label="$t('formularios.Direccion')"></v-text-field>
                  </v-col>
                  <v-col v-if="campodistrito" cols="12" sm="6" md="6">
                    <v-autocomplete  v-model="paisId" :items="paises"  item-value="id" item-text="pais" persistent-hint
                                     @change="cambiopais"
                                     single-line label="Escoger Pais"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campodistrito" cols="12" sm="6" md="6">
                    <v-autocomplete  v-model="provinciaId" :items="provincias" item-value="id" item-text="provincia" persistent-hint

                                     @change="cambioprovincia"
                                     single-line label="Escoger Departamento"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campodistrito" cols="12" sm="6" md="4">
                    <v-autocomplete  v-model="ciudadId" :items="ciudades" item-value="id" item-text="ciudad" persistent-hint

                                     @change="cambiociudad"
                                     single-line label="Escoger Provincia"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campodistrito" cols="12" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.distrito" :items="distritos" item-value="distritoId" item-text="distrito" persistent-hint
                                     return-object
                                     single-line :label="labelDistrito"></v-autocomplete>
                  </v-col>
                  <v-col v-if="camposexo" cols="12" sm="6" md="4">
                    <v-autocomplete  v-model="editedItem.sexo" :items="sexos" item-value="idSexo" item-text="Sexo"  persistent-hint
                                     return-object
                                     single-line :label="labelSexo"></v-autocomplete>
                  </v-col>
                  <v-col v-if="campofecnac" cols="12" sm="6" md="6">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="editedItem.fechaNacimiento" :label="labelFechaNacimiento"
                                      hint="YYYY-MM-DD" persistent-hint
                                      @blur="date = formatDate(editedItem.fechaNacimiento)"
                                      v-on="on"
                                      prepend-icon="fas fa-calendar" ></v-text-field></template>
                      <v-date-picker
                          v-model="date"
                          no-title
                          min="1950-01-01"
                          locale="es-es"
                          :first-day-of-week="1"
                          @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col v-if="camporeferido" cols="12" sm="6" md="4">
                    <v-text-field  v-model="referido" :label="$t('formularios.Referido')"></v-text-field>
                  </v-col>

                  <v-col v-if="camporef1"  cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.ref1" :label="labelRef1"></v-text-field>
                  </v-col>

                  <v-col  v-if="camporef2"  cols="12" sm="6" md="6">
                    <v-text-field v-bind:style="styleComponent" v-model="editedItem.ref2" :label="labelRef2"></v-text-field>
                  </v-col>
                  <v-col v-if="campocondiciones" cols="12" sm="12" md="12">

                    <v-checkbox
                        v-model="editedItem.aceptoCondicion"
                        :rules="[v => !!v || 'Debes aceptar para continuar']"
                        :label="condiciones"
                        required
                    ></v-checkbox>  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn v-bind:style="btnPag" :disabled="rest"  @click="save">Grabar</v-btn>
                  </v-col>
                </v-row>
              </v-form></v-card-text></v-card>
            </v-col>
          </v-row>

        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>
      </v-container-fluid>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "formulario",
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      tiposdoc: [{id:0,tipoDocumento:"Escoger Tipo de Documento",pais:{id:0,activo:false,codigo:'NN',pais:'NO PAIS',importancia: 0}}, {id:1, tipoDocumento:"DNI",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:2, tipoDocumento:"Carnet Extranjeria",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:3, tipoDocumento:"Pasaporte",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}],
      sexos: [{id:0,Sexo:"Escoger Sexo"}, {id:1, Sexo:"Masculino"}, {id:2, Sexo:"Femenino"}],
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      paises:[],
      rest: false,
      overlay:false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      camporef1: false,
      camporef2:false,
      condiciones: '',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido Paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Dni',
      labelDistrito: 'Distrito',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de Nacimiento',
      labelEmail:'Email',
      labelSexo:'Sexo',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      eventodisenio: {},
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Futura Bk BT',
        color: '#000000',
        paddingTop:'60px'
      },
      styleComponent:{
        color:'#000000',
      },
      styleCabecera:{
        color:'#000000',
        backgroundColor:'#ffffff'
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#000000',
        backgroundColor:'#ffffff',
        marginTop:'0px !important'
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      },
      tag:'',
      referido:'',
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  this.$route.params.tagevento;
    this.damedisenio();
  },
  methods: {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    scrollToCuerpo(){
      const el = this.$refs.cuerpo2;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollToCabecera(){
      const el = this.$refs.cuerpo;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    formatDateRe(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    dameprovincias(){
      axios
          .get('provincias/pais/'+this.paisId)
          .then(response => {
            this.provincias = response.data;
            this.dameciudades()

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/'+this.provinciaId)
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.ciudadId)
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    save(){
      var bodyFormData = new FormData();
      this.overlay = true;
      this.editedItem.fechaNacimiento = this.formatDateRe(this.editedItem.fechaNacimiento)
      if(this.camposexo === false){
        this.editedItem.sexo = {id:0,sexo:'SIN SEXO'};
      }
      if(this.editedItem.fechaNacimiento === "Fecha inválida"){
        this.editedItem.fechaNacimiento = "01-01-1995"
      }
        bodyFormData.append("referido",this.referido)
        bodyFormData.append("persona",JSON.stringify(this.editedItem))
        bodyFormData.append("tagevento",this.tagevento)
      bodyFormData.append("estadoEventoId",32)
      this.rest = true
      axios
          .post('tickets/grabar/formulario',bodyFormData)
          .then(response => {
            let ticketMin = response.data;
            console.log(ticketMin)
            this.alertnuevo = true
            this.rest = false
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    damedisenio(){
      axios
          .get('disenio/evento/'+this.tagevento)
          .then(response => {
            this.eventodisenio = response.data;
            console.log(this.eventodisenio);
            this.campoapmaterno= this.eventodisenio.campoapmaterno;
            this.labelApellidoMaterno = this.eventodisenio.labelApmaterno;
            this.labelApellidoPaterno = this.eventodisenio.labelAppaterno;
            this.campotelefono = this.eventodisenio.campotelefono;
            this.campoinvitado = this.eventodisenio.campoinvitado;
            this.camposexo = this.eventodisenio.camposexo;
            this.campodireccion = this.eventodisenio.campodireccion;
            this.campodistrito = this.eventodisenio.campodistrito;
            this.campofecnac  = this.eventodisenio.campofecnac;
            this.campofumador = this.eventodisenio.campofumador;
            this.logoexist = this.eventodisenio.logoCargado;
            this.logoimg = this.eventodisenio.logo;
            this.stylePagina.color = this.eventodisenio.colorText;
            this.btnPag.color = this.eventodisenio.colorTextBotn;
            this.btnPag.backgroundColor = this.eventodisenio.colorBgBoton;
            this.labelRef1 = this.eventodisenio.labelRef1;
            this.labelRef2 = this.eventodisenio.labelRef2;
            this.camporef1 = this.eventodisenio.camporef1;
            this.camporef2 = this.eventodisenio.camporef2;
            this.styleMain.backgroundSize = "cover";
            this.stylePagina.backgroundImage = "url('"+this.eventodisenio.backgroundImage+"')";

            this.styleCabecera.backgroundColor = this.eventodisenio.backCabeceraColor;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>

</style>